import MultiSelectField from './MultiSelectField';
export default MultiSelectField;
//# sourceMappingURL=index.js.map